module.exports = __webpack_public_path__ + "img/seal_1.d8cc9bc9.png";